import React from 'react';
import Image from './Image.jsx';

class ImageGrid extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'ImageGrid';


    // bind functions to component
    this.renderImages = this.renderImages.bind(this);
  }


  /**
   * Renders title
   * @returns {ReactElement} - A ReactElement
   */
  renderTitle() {
    const data = this.props.data;
    let title;

    if (data.title && data.title.length > 0) {
      title = (
        <div
          className='title col-6 large-col-8 large-push-2'
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
      );
    }

    return title;
  }


  /**
   * Renders images
   * @returns {Array<ReactElement>} - An array of ReactElements
   */
  renderImages() {
    const images = [];
    const data = this.props.data;

    for (let i = 0; i < data.images.length; i++) {
      const key = data.id + '-' + i + data.images[i].id;
      const prevSectionType = (i === 0) ? 'title' : 'image';
      const imageData = {
        landscape: data.images[i].landscape_images,
        portrait: data.images[i].portrait_images,
        credit: data.images[i].credit,
        alt: data.images[i].alt,
        id: data.images[i].id,
      };

      images.push(
        <Image
          data={imageData}
          gridPush={data.images[i].grid_push}
          gridPushGutter={data.images[i].grid_push_gutter}
          gridWidth={data.images[i].grid_width}
          iteration={i}
          key={key}
          largeGridPush={data.images[i].large_grid_push}
          largeGridPushGutter={data.images[i].large_grid_push_gutter}
          largeGridWidth={data.images[i].large_grid_width}
          lazy
          prevSectionType={prevSectionType}
          scrollTop={this.props.scrollTop}
          windowSize={this.props.windowSize}
        />
      );
    }

    return images;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const title = this.renderTitle();
    const images = this.renderImages();
    const data = this.props.data;
    const className = 'component-image-grid section-' + this.props.iteration + '-' +
      data.id + ' prev-section-type-' + this.props.prevSectionType;

    return (
      <section className={className}>
        {title}
        <div className='images'>
          {images}
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - The element data
 * @prop {Number} iteration - The iteration of the element
 * @prop {String} prevSectionType - The type of the previous section
 * @prop {Number} scrollTop - The amount, in pixels, the user has scrolled in
 * the entire article
 * @prop {Object} windowSize - An object holding the width
 * and size of the window
 */
ImageGrid.propTypes = {
  data: React.PropTypes.object,
  iteration: React.PropTypes.number,
  prevSectionType: React.PropTypes.string,
  scrollTop: React.PropTypes.number,
  windowSize: React.PropTypes.object,
};


export default ImageGrid;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/ImageGrid.jsx
 **/